import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { sendBrowse, sendAuthToken } from 'helpers/dawPlugin';
import { auth } from '@landr/root-app/auth';
import { useExecutionEnvironmentContext } from 'contexts/ExecutionEnvironmentContext/ExecutionEnvironmentContext';

export const useDawPlugin = () => {
    const { isDAWPlugin } = useExecutionEnvironmentContext();
    const location = useLocation();

    useEffect(() => {
        async function updateAuthTokenForDawPlugin() {
            const token = await auth.getToken();

            sendAuthToken(token ? token : '');
        }

        if (isDAWPlugin) {
            updateAuthTokenForDawPlugin();
            sendBrowse(location);
        }
        // Only run on location change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);
};
